import React, { Fragment } from 'react';

const FAQText = [
    {
        id: 0,
        question: "What is the difference among users' roles?",
        answer:
            <Fragment>
                <li>Company Administrators & Local Administrators: Have all the right to CRUD. This is suitable for project managers, team lead. </li>
                <li>Local Users & Support: Have the right to view the Live data and open Livefeed. This is suitable for maitenance purpose (Internal or 3rd-party team).</li>
            </Fragment>
    },
    {
        id: 1,
        question: "How to export data to CSV and inspect each individual data?",
        answer: `From the dashboard, choose the duration of exported data (current day, weeks, months or custom). \nSelect the desired location widget and click "Export data" button. Choose the "CSV: Data of sensors" option and Save the file to local machines.\nCSV data presents average hourly data of each SenzoUnit from chosen working hours. \nThe average data is calculated from "Mask" after formatting the value to binary string.`
    },
    {
        id: 2,
        question: "Could I choose different working hours for each location/building/department?",
        answer: 'Certainly. From dashboard, choose Settings on the top-right corner and select "Default Settings". User can add and modify the working hours and working days of each location.'
    },
    {
        id: 3,
        question: "SenzoLive API?",
        answer:
            <Fragment>
                Please check the SenzoLive API design here <br />
                <a target='_blank' rel="noopener noreferrer" href='https://app.swaggerhub.com/apis/Senzo_IT_Oy/Senzolive-3.0/1.0.0#/'>https://app.swaggerhub.com/apis/Senzo_IT_Oy/Senzolive-3.0/1.0.0#/</a><br />
                To generate API key, choose Settings on the top-right corner and select "SenzoAPI"
            </Fragment>
    },
    {
        id: 4,
        question: "What are the certifications of the sensor?",
        answer: "SenzoLive has passed for FCC and CB Testing including SAR Measurement."
    },
    {
        id: 5,
        question: "What type of data does the sensor collect?",
        answer: "The technology we use is proximity sensor (P/N: VCNL4010) to measure proximity signal. The data is used to calculate occupancy & efficiency level."
    },
    {
        id: 6,
        question: "What is the interval of collection data?",
        answer: 'By default, the SenzoUnit is collecting data every 2 minutes (the interval is adjustable). Once it reach the end of interval, SenzoUnit will send data to the server.'
    },
    {
        id: 7,
        question: 'What is the difference among "Unoccupied", "Occupied" and "Standby" indicators in Live view?',
        answer: "Unoccupied means the seat is free and available to use.\nOccupied means the seat is taken and being used.\nStandby means the occupant has left the seat during last 15 minutes (the Standby indication time is adjustable to suit different workspace's purposes)\nAll indicators are real-time value."
    },
    {
        id: 8,
        question: 'What is the meaning of "Offline" and "Maintenance" indicators in Live view?',
        answer: 'Offline means the SenzoUnit has connection issue recently up to 24 hours.\nMaintenance means the SenzoUnit has been offline for more than 24 hours and requires attention from technician.'
    },
    {
        id: 9,
        question: 'What are action points to fix the "Maintenance" sensor?',
        answer: 'Please check whether there is power is available for the SenzoUnit and micro USB cable is properly connected to it. For indication, the LED will blink once at the startup when plugged in.'
    },
    {
        id: 10,
        question: 'How to soft reset the sensor?',
        answer: 'On the back side of the SenzoUnit, (from left to right) there is a switch, micro USB slot, LED and reset button.\nMake sure the cable is attached to SenzoUnit and there is power (sensor will blink once at start up)\nPress and hold the reset button for 20 seconds until the SenzoUnit is blinking green. Switch the SenzoUnit to OFF (to left-hand side) and wait for 10 seconds.\nSwitch the SenzoUnit back to ON.\nCheck from the live view for new update.'
    }

];
export default (FAQText)



// WEBPACK FOOTER //
// ./src/components/pages/faq/FAQText.js